import { useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState } from "react";
import { SoknaderContext } from "./contexts/SoknaderContext";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowLeft, faEnvelope, faSave, faTrash} from "@fortawesome/free-solid-svg-icons";
import PersonaliaCard from "./PersonaliaCard";
import SoknadCard from "./SoknadCard";
import ArbeidsforholdCard from "./ArbeidsforholdCard";
import VedleggCard from "./VedleggCard";
import SoknadNotes from "./SoknadNotes";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function SoknadEdit() {

    const { id } = useParams();
    const {
        getSoknadById,
        soknad,
        updateSoknad,
        file,
        setFile,
        handleFileChange,
        handleUpload,
        trekkSoknad,
    } = useContext(SoknaderContext);
    const navigate = useNavigate();

    const readOnly = false;
    const [showFileModal, setShowFileModal] = useState(false);

    useEffect(() => {
        if (Number(id) === 0) {
            navigate("/soknader");
            return;
        }
        getSoknadById(Number(id));
    }, []);

    const handleCloseModal = () => {
        setShowFileModal(false);
        setFile(null);
    };
    const handleUploadFile = () => {
        setShowFileModal(false);
        handleUpload();
    };

    const handleSetShowFileModal = (value: boolean) => {
        setShowFileModal(value);
    }

    function submit(e:any) {
        e.preventDefault();
        updateSoknad();
    }

    function sendInnSoknad() {
        updateSoknad(true);
    }


    if (!soknad) {
        return (<>
            <div>Henter søknad...</div>
        </>);
    }

    return (<>
        <h3>
            Redigerer Søknad nr {soknad.id}
        </h3>
        <h4>Status: {soknad.status?.name ?? "Ny"}</h4>
        <hr />
        <Button className={"m-2"} disabled={!soknad} onClick={() => navigate("/soknader")}><FontAwesomeIcon
            icon={faArrowLeft}></FontAwesomeIcon> Tilbake</Button>
        {
            soknad.id!==0?
                <>
        <Button className={"m-2"} disabled={!soknad} onClick={sendInnSoknad}><FontAwesomeIcon
            icon={faEnvelope}></FontAwesomeIcon> Send inn søknad</Button>
                    <Button className={"m-2"}  disabled={readOnly} onClick={submit}><FontAwesomeIcon
                        icon={faSave}></FontAwesomeIcon> Lagre søknad (foreløpig ikke sendt inn)</Button>
        <Button className={"m-2 btn-secondary"} disabled={!soknad} onClick={trekkSoknad}><FontAwesomeIcon
            icon={faTrash}></FontAwesomeIcon> Trekk søknaden</Button>
                </>
            :null
}
        <hr />
        <Container>
            <Form onSubmit={submit}>
                <div className="p-1">
                    <SoknadNotes></SoknadNotes>
                </div>
                <div className="p-1">
                    <PersonaliaCard readOnly={readOnly} ></PersonaliaCard>
                </div>
                <div className="p-1">
                    <SoknadCard showFileUpload={handleSetShowFileModal} readOnly={readOnly} ></SoknadCard>
                </div>

                <div className="p-1">
                    <ArbeidsforholdCard readOnly={readOnly} ></ArbeidsforholdCard>
                </div>
                <div className="p-1">
                    <VedleggCard showFileUpload={handleSetShowFileModal} readOnly={readOnly} ></VedleggCard>
                </div>
                <Row className={"mt-4 mb-5"}>
                    <Col>
                        <Button type={"submit"} disabled={readOnly}><FontAwesomeIcon
                            icon={faSave}></FontAwesomeIcon> Lagre søknad (foreløpig ikke sendt inn)</Button>
                    </Col>
                </Row>
            </Form>
        </Container>

        <Modal show={showFileModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>Last opp nytt vedlegg</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Velg fil</label>
                    <div className="col-md-10">
                        <input
                            type="file"
                            className="form-control form-control-sm"

                            onChange={handleFileChange} />
                    </div>
                </div>
                {file && (
                    <section>
                        File details:
                        <ul>
                            <li>Name: {file.name}</li>
                            <li>Type: {file.type}</li>
                            <li>Size: {file.size} bytes</li>
                        </ul>
                    </section>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                    Avbryt
                </Button>
                <Button variant="primary" onClick={handleUploadFile}>
                    Last opp
                </Button>
            </Modal.Footer>
        </Modal>
        <ToastContainer></ToastContainer>
    </>);
}

export default SoknadEdit;